import { AegisClient } from '@nike/aegis-auth-react';
import getEnvironment from './getEnvironment';

const clientId = 'nike.content.composer';

const aegisClient = new AegisClient({
  clientId,
  redirectUri: window.location.origin,
  qa: getEnvironment() !== 'prod',
  scopes: ['openid', 'profile', 'email', 'groups'],
});

export default aegisClient;